import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Is Halo painful?',
  answer: 'We prioritize your comfort. A topical numbing cream is applied before the treatment, and the Halo device features integrated cooling technology. Most patients describe the sensation as a mild heat with occasional prickling.'
}, {
  question: 'How much downtime should I expect?',
  answer: "Unlike traditional ablative lasers that require weeks of hiding, Halo typically involves 3-5 days of 'social downtime.' Your skin will look sunburned initially, followed by a light peeling process. You can wear makeup after 24 hours."
}, {
  question: 'How many sessions will I need?',
  answer: 'Many patients see beautiful results after just one treatment. Depending on your specific skin concerns and goals, we may recommend a series of 2-3 sessions for optimal transformation.'
}, {
  question: 'Is this safe for my skin tone?',
  answer: "Yes. Because Halo is highly customizable, it is safe and effective for a wide variety of skin types and tones. During your consultation, we will assess your skin to ensure it's the right approach for you."
}, {
  question: 'How is Halo different from a regular laser facial?',
  answer: "Halo is the world's first hybrid fractional laser. It simultaneously delivers non-ablative (deep) and ablative (surface) wavelengths. This means you get the dramatic results of an aggressive laser with the minimal downtime of a mild one."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 md:py-32 bg-muted" data-id="element-77">
      <div className="container mx-auto px-4 md:px-8 max-w-3xl" data-id="element-78">
        <div className="text-center mb-16" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-serif text-foreground mb-4" data-id="element-80">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground/60 font-sans uppercase tracking-widest text-sm" data-id="element-81">
            Everything you need to know
          </p>
        </div>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, index) => <div key={index} className="bg-background border border-divider overflow-hidden transition-all duration-300" data-id="element-83">
              <button className="w-full px-6 py-6 flex items-center justify-between text-left focus:outline-none" onClick={() => toggleFAQ(index)} aria-expanded={openIndex === index} data-id="element-84">
                <span className="font-serif text-lg text-foreground pr-8" data-id="element-85">
                  {faq.question}
                </span>
                <ChevronDown className={`text-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-86" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-87">
                <p className="text-foreground/70 font-sans leading-relaxed" data-id="element-88">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}